import React, { ReactElement, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import TooltipSimple from '../../Common/TooltipSimple';
import { Client, HistoriqueLogs } from '../../../../../common/src/entities';
import { schemaClient } from '../../../../../common/src/schemas';
import ChampFormulaire from '../../Common/ChampFormulaire';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import ChampMultipleCentreServiceScolaire from '../Css/ChampMultipleCSS';
import ChampMultipleClientContact from '../Contacts/ChampMultipleClientContact';
import ChampMultipleClientLieu from '../Lieux/ChampMultipleClientLieu';
import { ModalClientContact } from './ModalClientContact';
import { ModalDetails } from '../../Common/ModalDetails';
import { BiHome, BiBusSchool, BiGroup, SiGoogleclassroom } from 'react-icons/all';
import { ReactComponent as SdgIcon } from '../../../Icons/sdg.svg';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import ChampMultipleRoles from './ChampMultipleRoles';
import { useGetQuery } from '../../../Utils/api';
import { GROUPES_AGES, LABEL_COL, SUGGESTIONS_LIEU, SUGGESTIONS_POSTE } from '../constantes';
import RolesContainer from '../RolesContainer';
import ChampUniqueLieu from '../Lieux/ChampUniqueLieu';
import { useFormikContext } from 'formik';
import { MyPaper } from '../Utils/MyPaper';
import { Tooltip } from '../../Common/Tooltip';

const SUGGESTIONS_PREFIX = ['N/A', 'SDG', 'École', 'Ville', 'Fournisseur'];

export function ChampsClient(): ReactElement {
    const { values } = useFormikContext<Client>();
    const [afficherModalClientContact, setAfficherModalClientContact] = useState<boolean>(false);
    const [indexModalClientContact, setIndexModalClientContact] = useState<number>(0);

    const [afficherModalClientLieu, setAfficherModalClientLieu] = useState<boolean>(false);
    const [indexModalClientLieu, setIndexModalClientLieu] = useState<number>(0);

    function ouvrirModalClientContact(index: number): void {
        setIndexModalClientContact(index);
        setAfficherModalClientContact(true);
    }

    function ouvrirModalClientLieu(index: number): void {
        setAfficherModalClientLieu(true);
        setIndexModalClientLieu(index);
    }
    return (
        <>
            <MyPaper>
                <Row>
                    <Col xs={LABEL_COL}>Nom</Col>
                    <Col xs={2} className="pr-0">
                        <ChampFormulaire
                            id="prefix"
                            suggestions={SUGGESTIONS_PREFIX}
                            isCreatable
                            cacherTitre
                            placeholder="Préfixe"
                            estPetit
                        />
                    </Col>
                    <Col>
                        <ChampFormulaire id="name" cacherTitre placeholder="Nom du client" estPetit />
                    </Col>
                </Row>
                <ChampMultipleCentreServiceScolaire
                    labelCol={LABEL_COL}
                    id="centre_service_scolaire"
                    maxSize={1}
                    avecUnBouton
                />
                <ChampFormulaire labelCol={LABEL_COL} id="courriel" titre="Courriel" estPetit />
                <ChampFormulaire labelCol={LABEL_COL} id="telephone" titre="Téléphone" estPetit />
                <ChampFormulaire
                    type="date"
                    id="fin_abonnement"
                    titre="Fin d'abonnement"
                    labelCol={LABEL_COL}
                    trimDateText
                    estPetit
                />
                <ChampMultipleClientContact
                    id="contacts"
                    labelCol={LABEL_COL}
                    avecUnBouton
                    details={formikAvoirPoste}
                    suggestions={SUGGESTIONS_POSTE}
                    placeholder="Poste"
                    clickCrayon={ouvrirModalClientContact}
                />
                <RolesContainer key={values.roles}>
                    <ChampMultipleRoles numeroRole={1} nomRole={"Planification d'activité"} />
                    <ChampMultipleRoles numeroRole={2} nomRole={"Approbation d'activité"} />
                    <ChampMultipleRoles numeroRole={3} nomRole={'Organisation de parascolaires'} />
                    <ChampMultipleRoles numeroRole={4} nomRole={'Facturation'} />
                </RolesContainer>
                <ChampMultipleClientLieu
                    id="lieux"
                    labelCol={LABEL_COL}
                    avecUnBouton
                    details={formikAvoirDetailLieu}
                    suggestions={SUGGESTIONS_LIEU}
                    placeholder="Detail"
                    clickCrayon={ouvrirModalClientLieu}
                />
                <ChampUniqueLieu
                    id="adresse_facturation"
                    placeholder="Aucune adresse"
                    lieux={values.lieux}
                    label={'Adresse de facturation'}
                    titreBouton="Choisir une adresse"
                    selectedLieu={values.adresse_facturation}
                />
                <Row>
                    <Col xs={LABEL_COL}>Paramètres de réservation</Col>
                    <Col xs={12 - LABEL_COL}>
                        <Row style={{ marginLeft: 0 }}>
                            <TooltipSimple texte="# moyen pédago (par défaut)" disabled={false}>
                                <a>
                                    <span className="mr-1">#{<BiHome size="1.5em" />}</span>
                                </a>
                            </TooltipSimple>{' '}
                            <Col className="pr-0" style={{ paddingLeft: '0px', marginRight: '15px' }}>
                                <ChampFormulaire id="nb_avg_pedago" cacherTitre estPetit />
                            </Col>
                            <TooltipSimple texte="# moyen sortie" disabled={false}>
                                <a>
                                    <span className="mr-1">#{<BiBusSchool size="1.5em" />}</span>
                                </a>
                            </TooltipSimple>{' '}
                            <Col className="pr-0" style={{ paddingLeft: '0px', marginRight: '15px' }}>
                                {/* TODO type number */}
                                <ChampFormulaire id="nb_avg_sortie" cacherTitre estPetit />
                            </Col>
                            <TooltipSimple texte="# SDG total" disabled={false}>
                                <a>
                                    <span className="mr-1">#{<SdgIcon />}</span>
                                </a>
                            </TooltipSimple>{' '}
                            <Col className="pr-0" style={{ paddingLeft: '0px', marginRight: '15px' }}>
                                <ChampFormulaire id="nb_sdg_total" cacherTitre estPetit />
                            </Col>
                            <TooltipSimple texte="# d'élèves total" disabled={false}>
                                <a>
                                    <span className="mr-1">#{<BiGroup size="1.5em" />}</span>
                                </a>
                            </TooltipSimple>{' '}
                            <Col className="pr-0" style={{ paddingLeft: '0px', marginRight: '15px' }}>
                                <ChampFormulaire id="nb_eleves_total" cacherTitre estPetit />
                            </Col>
                            <TooltipSimple texte="# de groupe-classe" disabled={false}>
                                <a>
                                    <span className="mr-1">#{<SiGoogleclassroom size="1.5em" />}</span>
                                </a>
                            </TooltipSimple>{' '}
                            <Col className="pr-0" style={{ paddingLeft: '0px', marginRight: '15px' }}>
                                <ChampFormulaire id="nb_groupe_classe" cacherTitre estPetit />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <ChampFormulaire
                    labelCol={LABEL_COL}
                    suggestions={GROUPES_AGES}
                    isCreatable
                    id="groupe_age"
                    titre="Groupe d'âge"
                    estPetit
                />
                <ChampFormulaire
                    labelCol={LABEL_COL}
                    isCreatable
                    id="grandeur_gym"
                    titre="Grandeur du gymnase"
                    estPetit
                />
                <ChampFormulaire labelCol={LABEL_COL} id="notes" titre="Notes internes" textarea />
                <ChampFormulaire
                    labelCol={LABEL_COL}
                    id="notes_fournisseur"
                    titre={
                        <>
                            Notes pour le fournisseur{' '}
                            <Tooltip tooltip="Visible pour le fournisseur dans les documents." id="tooltip-1" />
                        </>
                    }
                    textarea
                />
                <ChampFormulaire
                    labelCol={LABEL_COL}
                    id="notes_client"
                    titre={
                        <>
                            Notes pour le client{' '}
                            <Tooltip tooltip="Visible pour le client dans les documents." id="tooltip-2" />
                        </>
                    }
                    textarea
                />
            </MyPaper>
            {afficherModalClientContact ? (
                <ModalClientContact
                    afficher={afficherModalClientContact}
                    setAfficher={() => setAfficherModalClientContact(false)}
                    index={indexModalClientContact}
                />
            ) : null}
            {afficherModalClientLieu ? (
                <ModalDetails
                    afficher={afficherModalClientLieu}
                    setAfficher={() => setAfficherModalClientLieu(false)}
                    detailId={formikAvoirDetailLieu(indexModalClientLieu)}
                    titre={'Détails sur le lieu'}
                    suggestions={SUGGESTIONS_LIEU}
                />
            ) : null}
        </>
    );
}

/**
 * Pour pouvoir assigner les postes (qui est une entité client-contact) dans un champ
 * multiple qui est une entité client.
 * @param index position dans le tableau des contacts
 */
function formikAvoirPoste(index: number): string {
    return `contacts[${index}].poste`;
}
function formikAvoirDetailLieu(index: number): string {
    return `lieux[${index}].detail`;
}

export default function DetailsClient(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/client`);

    return (
        <div>
            <FormulaireModificationEntite
                id={+id}
                entite={Client}
                badges={(c: Client) => [
                    `Client #${c.id}`,
                    `Dernière modification: ${
                        listLogs.data?.[listLogs.data.length - 1]?.date_modification
                            ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                            : 'Aucune modificiation'
                    }  ${
                        listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                            ? ' par ' + listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                            : ''
                    }`,
                ]}
                schema={schemaClient}
                properties_to_reassign={{
                    centre_service_scolaire: 'fk_centre_service_scolaire',
                }}
            >
                <ChampsClient />
            </FormulaireModificationEntite>
            <LogsLoader id={id} tableName={'client'} />
        </div>
    );
}
